import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import * as _ from 'lodash';
import { FieldEnum } from 'Common/FieldEnum';
import { isValidEmail } from 'Common/FormHelper';

import { SelectField, CheckboxField, InputField } from 'Common/SemanticWrapper';
import { StyledReduxFormError } from 'Components';

class EditForm extends Component {
  componentDidMount() {
    //Hack below
    //if precviously got a redux form error, it would never reset
    this.props.setIsValid(true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.valid !== this.props.valid) {
      this.props.setIsValid(nextProps.valid);
    }
  }

  renderPassword = () => {
    if (this.props.showPassword) {
      return (
        <Grid.Row>
          <Grid.Column>
            <Field
              name={FieldEnum.Password}
              component={InputField}
              type="password"
              placeholder="Password"
              autoComplete="off"
              label={'Password'}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name={FieldEnum.ConfirmPassword}
              component={InputField}
              type="password"
              placeholder="Confirm Password"
              autoComplete="off"
              label={'Confirm Password'}
            />
          </Grid.Column>
        </Grid.Row>
      );
    }
  };

  render() {
    const { handleSubmit, error, availableRoles } = this.props;

    let transformedData = [];
    availableRoles.map((role, index) => {
      transformedData.push({
        key: index,
        text: role.Description,
        value: role.Id,
      });
      return null;
    });

    return (
      <div>
        <Form onSubmit={handleSubmit}>
          <Grid columns={3}>
            <Field name={FieldEnum.Id} component="input" type="hidden" />
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={FieldEnum.Username}
                  component={InputField}
                  type="text"
                  placeholder="Username"
                  maxLength={30}
                  label={'Username'}
                  autoFocus={true}
                  autoComplete="off"
                  disabled={this.props.disableUserName}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={FieldEnum.FirstName}
                  component={InputField}
                  type="text"
                  placeholder="First Name"
                  autoComplete="off"
                  label={'First Name'}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={FieldEnum.LastName}
                  component={InputField}
                  type="text"
                  placeholder="Last Name"
                  autoComplete="off"
                  label={'Last Name'}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name={FieldEnum.RoleId}
                  component={SelectField}
                  type="text"
                  placeholder="User Role"
                  options={transformedData}
                  label="User Role"
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={FieldEnum.Email}
                  component={InputField}
                  type="text"
                  placeholder="Email"
                  autoComplete="off"
                  label={'Email'}
                />
              </Grid.Column>
            </Grid.Row>

            {this.renderPassword()}

            <Grid.Row>
              <Grid.Column>
                <label>Inactive</label>
                <Field name={FieldEnum.IsActive} component={CheckboxField} />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <StyledReduxFormError error={error} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (props.isNew === true && values[FieldEnum.Username]) {
    const foundUser = _.find(props.userSetup.Data, x => {
      return (
        x.UserName.toLowerCase() === values[FieldEnum.Username].toLowerCase()
      );
    });
    if (foundUser) {
      errors[FieldEnum.Username] = 'The username must be unique.';
    }
  }

  if (
    !values[FieldEnum.Username] ||
    _.trim(values[FieldEnum.Username]).length === 0
  ) {
    errors[FieldEnum.Username] = 'Username is required.';
  }

  if (
    !values[FieldEnum.FirstName] ||
    _.trim(values[FieldEnum.FirstName]).length === 0
  ) {
    errors[FieldEnum.FirstName] = 'First name is required.';
  }

  if (
    !values[FieldEnum.LastName] ||
    _.trim(values[FieldEnum.LastName]).length === 0
  ) {
    errors[FieldEnum.LastName] = 'Last name is required.';
  }

  if (
    values[FieldEnum.Email] &&
    _.trim(values[FieldEnum.Email]).length > 0 &&
    !isValidEmail(values[FieldEnum.Email])
  ) {
    errors[FieldEnum.Email] = 'Please enter a valid email address.';
  }

  if (props.showPassword) {
    if (!values[FieldEnum.Password]) {
      errors[FieldEnum.Password] = 'Password is required.';
    }

    if (!values[FieldEnum.ConfirmPassword]) {
      errors[FieldEnum.ConfirmPassword] = 'Password is required.';
    }

    if (values[FieldEnum.Password] && values[FieldEnum.Password].length < 6) {
      errors[FieldEnum.Password] = 'Password must be at least 6 characters.';
    }

    if (
      values[FieldEnum.ConfirmPassword] &&
      values[FieldEnum.ConfirmPassword].length < 6
    ) {
      errors[FieldEnum.ConfirmPassword] =
        'Password must be at least 6 characters.';
    }

    if (values[FieldEnum.ConfirmPassword] && values[FieldEnum.Password]) {
      if (values[FieldEnum.ConfirmPassword] !== values[FieldEnum.Password]) {
        errors[FieldEnum.ConfirmPassword] = 'Passwords must match.';
      }
    }
  }

  return errors;
};

export default reduxForm({
  validate,
  enableReinitialize: true,
  form: 'UserSetupForm',
})(EditForm);



// WEBPACK FOOTER //
// ./src/pages/usersetup/components/EditForm.js